import { DataBean } from "../DataBean";

export class ImportAgency extends DataBean {




    public async importAgencyCatalog(filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importAgencyCatalog_String_String_String", [filename, directory, dataStore]);
    }

}